/**
 * Styling for KPI chart margins
 * @type {{top: number, left: number, bottom: number, right: number}}
 */
export const chartMargins = { top: 20, right: 30, left: 10, bottom: 15 }

/**
 * Styling for KPI chart legends
 * @type {{paddingBottom: string}}
 */
export const legendStyling = {
  paddingBottom: '10px'
}
